import { render } from "./FloatLabelDemo.vue?vue&type=template&id=2da08c3a&scoped=true"
import script from "./FloatLabelDemo.vue?vue&type=script&lang=js"
export * from "./FloatLabelDemo.vue?vue&type=script&lang=js"

import "./FloatLabelDemo.vue?vue&type=style&index=0&id=2da08c3a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da08c3a"]])

export default __exports__